var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 8.953C8.14878 8.953 9.08004 8.02174 9.08004 6.873C9.08004 5.72422 8.14878 4.79297 7.00004 4.79297C5.85131 4.79297 4.92004 5.72422 4.92004 6.873C4.92004 8.02174 5.85131 8.953 7.00004 8.953Z",
    stroke: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4133 5.65992C2.72664 -0.113413 11.28 -0.106746 12.5867 5.66659C13.3533 9.05325 11.2467 11.9199 9.4 13.6933C8.06 14.9866 5.94 14.9866 4.5933 13.6933C2.7533 11.9199 0.646635 9.04659 1.4133 5.65992Z",
    stroke: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.5e81c593cdbce8938a96f2fc95f3c843.svg";
export { ForwardRef as ReactComponent };